<div class="parameters-form parameters-form__section-separator" *ngIf="this.isAqlEnabled || this.isTgsEnabled">
  <div class="p-grid p-nogutter">
    <div class="p-col-3">
      <h2 class="parameters-form__title">{{ 'SAMPLING.SAMPLING_ESTIMATION_TITLE' | translate }}</h2>
    </div>

    <div class="p-col-8 parameters-form__table">
      <div *ngIf="this.isAqlEnabled" class="parameter-row parameter-row-divider">
        <label class="parameters-form__table-item-label">{{ 'SAMPLING.AQL' | translate }}</label>
        <span class="parameter-field">
          {{
            'SAMPLING.AQL_SAMPLING_DETAILS'
              | translate
                : {
                    aqlPerPiecesSampleQuantity: aqlPerPiecesSampleQuantity | formatQuantity,
                    aqlSampleQuantity: aqlSampleQuantity | formatQuantity,
                  }
          }}
        </span>
      </div>

      <div *ngIf="this.isTgsEnabled" class="parameter-row parameter-row-divider">
        <label class="parameters-form__table-item-label">{{ 'SAMPLING.TGS' | translate }}</label>
        <span class="parameter-field">
          {{
            'SAMPLING.TGS_SAMPLING_DETAILS'
              | translate
                : {
                    tgsPerPiecesSampleQuantity: tgsPerPiecesSampleQuantity | formatQuantity,
                    tgsSampleQuantity: tgsSampleQuantity | formatQuantity,
                  }
          }}
        </span>
      </div>
    </div>
  </div>
</div>
